<div
  class="lui-drawer-panel"
  *ngIf="usePanel"
  [class.lui-drawer-panel-start]="position === 'start'"
  [class.lui-drawer-panel-end]="position === 'end'"
>
  <div class="lui-drawer-panel-container">
    <div class="lui-drawer-panel-control-content">
      <ng-content select="[drawerPanelContent]"></ng-content>
    </div>
    <div class="lui-drawer-panel-control">
      <ng-content select="[drawerPanelControl]"></ng-content>
    </div>
  </div>
</div>
<div
  class="lui-drawer-inner-container d-flex flex-column flex-1"
  cdkScrollable
  #content
>
  <ng-content></ng-content>
</div>
